import { AxiosResponse } from "axios";

import {
  IIntegrationMessagePayload,
  IIntegrationQueueEntry,
} from "../../@types/admin/AdminIntegrationQueue";
import { api } from "../api";

/**
 * Integration queue inspector (EN-5174), replacing the read half of Retool's
 * eMED Demo page. Read-only, and served only in development and staging — the
 * API returns 404 in UAT and production.
 */
export const integrationQueueService = {
  /** The newest inbound integration messages and their queue state. */
  async getQueueEntries(
    processName?: string
  ): Promise<AxiosResponse<IIntegrationQueueEntry[]>> {
    return api.get<IIntegrationQueueEntry[]>("/Retool/IntegrationQueue", {
      params: processName ? { processName } : undefined,
    });
  },

  /** One message's raw payload. */
  async getMessagePayload(
    id: string
  ): Promise<AxiosResponse<IIntegrationMessagePayload>> {
    return api.get<IIntegrationMessagePayload>(
      `/Retool/IntegrationQueue/${id}`
    );
  },
};
